var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('ProductList',{attrs:{"productList":_vm.GetProductList},on:{"reload":_vm.loadData}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }